import React from 'react';
const Moment = require('moment');

const propTypes = {

};

const defaultProps = {

};

function CurrentYear(props) {
    return <span>{Moment().year()}</span>;
}

CurrentYear.propTypes = propTypes;
CurrentYear.defaultProps = defaultProps;

export default CurrentYear;